export enum PermissionAction {
  CREATE = 'Create',
  UPDATE = 'Update',
  DELETE = 'Delete',
}

export enum ResourcePolicy {
  SUBSCRIPTION = 'Subscription',
}
